<div
    *ngIf="budget"
    class="modal-header">
    <h2 class="modal-title">
        <i
            *ngIf="budget.recurring"
            [ngbTooltip]="recurringTip"
            class="las la-redo-alt m-r-2"></i>
        {{ budget.budgetType }} <span>for <app-pill-employee [employeeId]="budget.linkedEmployee.uuid" class="m-l-2"></app-pill-employee></span>
        <ng-template #recurringTip>Recurring budget</ng-template>
    </h2>

    <button
        (click)="activeModal.dismiss()"
        aria-label="Close"
        class="close"
        type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<nav
    #nav="ngbNav"
    class="tabs__modal"
    ngbNav>
    <ng-container ngbNavItem>
        <a ngbNavLink>Information</a>
        <ng-template ngbNavContent>
            <div *ngIf="budget; else loading">
                <app-primary-message
                    (click)="openAddBudgetModal()"
                    *ngIf="attentionLevel === 1 || attentionLevel === 2"
                    [messageSuccess]="messageSuccess"
                    [messageUrgent]="messageUrgent"
                    [messageWarning]="messageWarning"
                    [message]="messageBody"
                    [title]="messageTitle">
                </app-primary-message>
                <ul class="list__specs">
                    <li>
                        <label>Total to spend</label>
                        <span>{{ getTotalToSpend(budget) | currency: 'EUR' }}</span>
                        
                    </li>
                    <li *ngIf="budget.recurring">
                        <label>Total to spend ({{ budget.repeat}}) </label>
                        <span>{{ budget.totalSpend | currency: 'EUR' }}</span>
                    </li>
                    <li *ngIf="budget.budgetExpenditures !== null && budget.budgetExpenditures.length > 0">
                        <label>Total budget spend</label>
                        <span
                            [ngClass]="{
                                overBudget: getTotalSpendPercentage(budget) > 100
                            }"
                            class="d-flex flex-column align-items-center"
                            >{{ totalSpend | currency: 'EUR' }} - 
                            <app-percentage-progress
                                [percentage]="getTotalSpendPercentage(budget)"
                                [showPercentage]="true"></app-percentage-progress>
                        </span>
                    </li>
                    <li *ngIf="budget.budgetExpenditures !== null && budget.budgetExpenditures.length > 0">
                        <label>Remaining budget</label>
                        <span
                            [ngClass]="{
                                overBudget: getTotalSpendPercentage(budget) > 100
                            }"
                            >{{ this.getTotalToSpend(budget) - totalSpend | currency: 'EUR' }}</span
                        >
                    </li>

                    <li>
                        <label>Start date</label><span>{{ budget.startDate | date }}</span>
                    </li>
                    <li>
                        <label>End date</label><span>{{ budget.endDate | date }}</span>
                    </li>

                    <li>
                        <label>Sends notification</label>
                        <span *ngIf="budget.sendNotification"
                            ><i
                                class="las la-check-circle"
                                style="color: green"></i
                        ></span>
                        <span *ngIf="!budget.sendNotification"
                            ><i
                                class="las la-times-circle"
                                style="color: red"></i
                        ></span>
                    </li>
                    <li *ngIf="budget.sendNotification">
                        <label>Notification send after</label>
                        <span>{{ budget.notificationDate | date }}</span>
                    </li>

                    <ng-container *ngIf="budget.recurring">
                        <li>
                            <label>Repeats</label>
                            <span>{{ findRepeat(budget.repeat).title }}</span>
                        </li>
                    </ng-container>

                    <li>
                        <label>Financial</label>
                        <span>
                            <ng-container *ngIf="budget.useExpendituresForFinancials">
                                Only expenditures
                            </ng-container>
                            <ng-container *ngIf="!budget.useExpendituresForFinancials">
                                Budgeted cost
                            </ng-container>
                        </span>
                    </li>
                </ul>
            </div>
        </ng-template>
    </ng-container>

    <ng-container ngbNavItem>
        <a ngbNavLink>Expenditures</a>
        <ng-template ngbNavContent>
            <div
                *ngIf="budget; else loading"
                class="table__overflow">

                <p *ngIf="budget.useExpendituresForFinancials" class="form-helptext">
                    This budget only uses expenditures for financials. When no expenditures are added, the cost for this budget will be 0.
                </p>

                <!-- Add filter -->
                <div class="d-flex m-r-2">
                <div class="form-group m-r-2">
                    <label for="startDate">Start date</label>
                    <input
                    (change)="executeFilter()"
                    [(ngModel)]="startDate"
                    class="input--bg-transparant"
                    id="startDate"
                    type="date" />
                </div>

                <div class="form-group m-r-2">
                    <label for="endDate">End date</label>
                    <input
                    (change)="executeFilter()"
                    [(ngModel)]="endDate"
                    class="input--bg-transparant"
                    id="endDate"
                    type="date" />
                </div>

                <div class="form-group d-flex align-items-end">
                    <button
                    class="button button--primary"
                    (click)="executeFilter()"
                    type="button">
                    Filter
                    </button>
                </div>
                </div>

                <table
                    [dataSource]="filteredExpenditures"
                    mat-table
                    matSort>

                    <!-- Description -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                        <td mat-cell *matCellDef="let budgetExpenditure">
                        {{ budgetExpenditure.expenditure }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Cost -->
                    <ng-container matColumnDef="cost">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cost</th>
                        <td mat-cell *matCellDef="let budgetExpenditure">
                        {{ budgetExpenditure.cost | currency: 'EUR' }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef>
                        <strong>{{ totalFilteredCost | currency: 'EUR' }}</strong>
                        </td>
                    </ng-container>

                    <!-- Date -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                        <td mat-cell *matCellDef="let budgetExpenditure">
                        {{ budgetExpenditure.date | date }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Factuur -->
                    <ng-container matColumnDef="factuur">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Factuur</th>
                        <td mat-cell *matCellDef="let budgetExpenditure">
                        <app-pill-pdf
                            *ngIf="budgetExpenditure.invoiceUrl"
                            [exists]="budgetExpenditure.invoiceUrl"
                            [fileName]="getFileName(budgetExpenditure.invoiceUrl)"
                            [pdfAsBase64$]="getBase64(budgetExpenditure)"
                            [url]="budgetExpenditure.invoiceUrl">
                        </app-pill-pdf>
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Edit -->
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef class="td-small">
                        <span ngbDropdown>
                            <button
                            (click)="$event.stopPropagation()"
                            class="button button--icon button--dropdown button--small m-l-1"
                            ngbDropdownToggle></button>
                            <span class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                            <app-table-settings
                                [allColumns]="getAllColumns()"
                                [defaultColumns]="getDefaultColumns()"
                                [tableId]="'budget-detail'"></app-table-settings>
                            </span>
                        </span>
                        </th>
                        <td mat-cell *matCellDef="let budgetExpenditure" class="td-small">
                        <span class="dropdown" ngbDropdown>
                            <button
                            class="button button--icon button--small dropdown-toggle"
                            id="dropdownExpenditures"
                            ngbDropdownToggle></button>
                            <div
                            aria-labelledby="dropdownExpenditures"
                            class="dropdown-menu dropdown-menu-right"
                            ngbDropdownMenu>
                            <a
                                (click)="openUpdateBudgetExpenditureModal(budgetExpenditure)"
                                *appIsPermitted="{ module: 'BUDGET', operator: 'AND', actions: ['UPDATE'] }"
                                class="dropdown-item">Edit budget expenditure</a>
                            <a
                                (click)="deleteBudgetExpenditure(budgetExpenditure)"
                                *appIsPermitted="{ module: 'BUDGET', operator: 'AND', actions: ['DELETE'] }"
                                class="dropdown-item color--red">Delete</a>
                            </div>
                        </span>
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Add row (last row with plus button) -->
                    <ng-container matColumnDef="add">
                        <td
                        (click)="openAddBudgetExpenditureModal()"
                        *matFooterCellDef
                        class="table-view__add"
                        colspan="5"
                        mat-footer-cell>
                        <i class="las la-plus"></i> Add budget expenditure
                        </td>
                    </ng-container>

                    <!-- Row definitions -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    <!-- An empty table used to show nothing but its headers, which reads as broken rather than empty. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No results.</td>
                    </tr>
                    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                    <tr mat-footer-row *matFooterRowDef="['add']"></tr>
                    </table>

            </div>
        </ng-template>
    </ng-container>
</nav>

<div class="modal-body">
    <div [ngbNavOutlet]="nav"></div>
</div>

<div class="modal-footer">
    <span
        class="dropdown"
        ngbDropdown>
        <button
            class="button dropdown-toggle"
            id="dropdownMenuButton"
            ngbDropdownToggle>
            Options
        </button>
        <div
            aria-labelledby="dropdownMenuButton"
            class="dropdown-menu dropdown-menu-right"
            ngbDropdownMenu>
            <div *ngIf="budget; else loading">
                <span *ngIf="budget.archived; else isNotArchived">
                    <span
                        *appIsPermitted="{
                            module: 'BUDGET',
                            operator: 'AND',
                            actions: ['DELETE']
                        }">
                        <a
                            (click)="openArchiveBudgetModal()"
                            class="dropdown-item color--red"
                            >Unarchive budget</a
                        >
                        <a
                            (click)="openDeleteBudgetModal()"
                            class="dropdown-item color--red"
                        >Delete budget</a
                        >
                    </span>
                </span>
                <ng-template #isNotArchived>
                    <a
                        (click)="openBudgetUpdateModal()"
                        *appIsPermitted="{
                            module: 'BUDGET',
                            operator: 'AND',
                            actions: ['UPDATE']
                        }"
                        class="dropdown-item"
                        >Edit budget</a
                    >
                    <div class="dropdown-divider"></div>
                    <a
                        (click)="openArchiveBudgetModal()"
                        class="dropdown-item color--red"
                        >Archive budget</a
                    >
                    <a
                        (click)="openDeleteBudgetModal()"
                        class="dropdown-item color--red"
                    >Delete budget</a
                    >
                </ng-template>
            </div>
        </div>
    </span>
</div>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
